import { throttle, without } from 'lodash';
import React, { useEffect } from 'react';
import { emitEvent, useList } from '../../../services/deepstream';
import { useCurrentBoard, useCurrentUser } from '../../../services/state';
import UserBadge from './UserBadge';
import Cursor from './Cursor';
import NodeDragImage from './NodeDragImage';

import '../../../style/Common.css';
import './Cursor.css';

const Cursors = () => {
  const { id: boardId, draggedNodeId } = useCurrentBoard();
  const { id: userId } = useCurrentUser();

  const presentUserIds = useList(`room/${boardId}`);
  const otherUserIds = without(presentUserIds, userId);
  const otherUsersArePresent = otherUserIds.length > 0;

  const draggedNodes = useList(`board/${boardId}/dragged-nodes`);
  const draggedNodesOfOtherUsers = draggedNodes.filter(entry => !entry.startsWith(`${userId}/`));

  useEffect(() => {
    if (!otherUsersArePresent) return;

    const mouseMoveEvent = `project/${boardId}/user/${userId}/mousemove`;
    const emitMouseMove = throttle(({ pageX, pageY }) => {
      const percentageX = parseInt((pageX / window.innerWidth) * 100);
      const percentageY = parseInt((pageY / window.innerHeight) * 100);
      emitEvent(mouseMoveEvent, { percentageX, percentageY, draggedNodeId });
    }, 100);

    document.getElementById('circlyapp-editor-canvas').addEventListener('mousemove', emitMouseMove);
    document.getElementById('circlyapp-editor-canvas').addEventListener('drag', emitMouseMove);

    return () => {
      const editorCanvas = document.getElementById('circlyapp-editor-canvas');
      if (editorCanvas) {
        editorCanvas.removeEventListener('mousemove', emitMouseMove);
        editorCanvas.removeEventListener('drag', emitMouseMove);
      }
    };
  }, [userId, boardId, otherUsersArePresent, draggedNodeId]);

  return (
    <div>
      <div className="Presence">
        <div className="PresenceSection">
          {otherUserIds.map(userId => (
            <UserBadge userId={userId} key={userId} />
          ))}
        </div>
      </div>

      {otherUserIds.map(userId => (
        <Cursor userId={userId} key={userId} />
      ))}

      {draggedNodesOfOtherUsers.map(draggedNodeEntry => {
        const [userId, nodeId] = draggedNodeEntry.split('/');
        return <NodeDragImage key={userId} userId={userId} nodeId={nodeId} />;
      })}
    </div>
  );
};

export default Cursors;
